module.exports={...require("./middleware"),...require("./response"),...require("./router"),...require("./classes")};